export default __webpack_public_path__ + "dc8daae08702592f35cfc53a83408fa4.svg";